import { AsyncPipe } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, EventEmitter, Component, ChangeDetectionStrategy, Output, Input } from '@angular/core';
import * as i1 from '@taiga-ui/core';
import { tuiGetViewportWidth, TuiButton, TuiDropdown, TuiHint } from '@taiga-ui/core';
import { TUI_EDITOR_OPTIONS, TUI_EDITOR_TOOLBAR_TEXTS } from '@taiga-ui/editor/common';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { map } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { TuiRepeatTimes } from '@taiga-ui/cdk';
function TuiTableSizeSelector_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function TuiTableSizeSelector_div_0_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select());
    })("mouseenter", function TuiTableSizeSelector_div_0_div_1_Template_div_mouseenter_0_listener($event) {
      const y_r3 = i0.ɵɵrestoreView(_r1).$implicit;
      const x_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateCurrentSize(y_r3 + 1, x_r4 + 1, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r3 = ctx.$implicit;
    const x_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("t-cell_hovered", ctx_r1.tableSelectHovered(y_r3, x_r4));
  }
}
function TuiTableSizeSelector_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, TuiTableSizeSelector_div_0_div_1_Template, 1, 2, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tuiRepeatTimesOf", ctx_r1.rowsNumber);
  }
}
function TuiTableCreate_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-table-size-selector", 4);
    i0.ɵɵlistener("selectSize", function TuiTableCreate_ng_template_6_Template_tui_table_size_selector_selectSize_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addTable($event));
    });
    i0.ɵɵelementEnd();
  }
}
const MAX_COLS_NUMBER = 15;
const MAX_ROWS_NUMBER = 15;
const MIN_DISTANCE_PX = 70;
let TuiTableSizeSelector = /*#__PURE__*/(() => {
  class TuiTableSizeSelector {
    constructor() {
      this.win = inject(WINDOW);
      this.tableSize = {
        rows: 1,
        cols: 1
      };
      this.selectSize = new EventEmitter();
    }
    get columnsNumber() {
      return Math.min(Math.max(3, this.tableSize.cols + 1), MAX_COLS_NUMBER);
    }
    get rowsNumber() {
      return Math.min(Math.max(3, this.tableSize.rows + 1), MAX_ROWS_NUMBER);
    }
    tableSelectHovered(x, y) {
      return x < this.tableSize.rows && y < this.tableSize.cols;
    }
    updateCurrentSize(rows, cols, event) {
      if (tuiGetViewportWidth(this.win) - event.clientX > MIN_DISTANCE_PX) {
        this.tableSize = {
          rows,
          cols
        };
      }
    }
    select() {
      this.selectSize.emit(this.tableSize);
    }
    static {
      this.ɵfac = function TuiTableSizeSelector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTableSizeSelector)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiTableSizeSelector,
        selectors: [["tui-table-size-selector"]],
        outputs: {
          selectSize: "selectSize"
        },
        decls: 3,
        vars: 3,
        consts: [["class", "t-column", 4, "tuiRepeatTimes", "tuiRepeatTimesOf"], [1, "t-description"], [1, "t-column"], ["class", "t-cell", 3, "t-cell_hovered", "click", "mouseenter", 4, "tuiRepeatTimes", "tuiRepeatTimesOf"], [1, "t-cell", 3, "click", "mouseenter"]],
        template: function TuiTableSizeSelector_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiTableSizeSelector_div_0_Template, 2, 1, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("tuiRepeatTimesOf", ctx.columnsNumber);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("", ctx.tableSize.cols, "\xD7", ctx.tableSize.rows, "");
          }
        },
        dependencies: [TuiRepeatTimes],
        styles: ["[_nghost-%COMP%]{display:block;padding:.75rem}.t-cell[_ngcontent-%COMP%]{display:inline-block;background-color:var(--tui-background-base);inline-size:1.25rem;block-size:1.25rem;border-radius:.25rem;margin:.125rem;border:.0625rem solid var(--tui-border-normal);cursor:pointer}.t-cell_hovered[_ngcontent-%COMP%]{background-color:var(--tui-background-base-alt)}.t-column[_ngcontent-%COMP%]{white-space:nowrap}.t-description[_ngcontent-%COMP%]{text-align:center}"],
        changeDetection: 0
      });
    }
  }
  return TuiTableSizeSelector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTableCreate = /*#__PURE__*/(() => {
  class TuiTableCreate {
    constructor() {
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.texts$ = inject(TUI_EDITOR_TOOLBAR_TEXTS);
      this.insertTableText$ = this.texts$.pipe(map(texts => texts.insertTable));
      this.inputEditor = null;
    }
    get editor() {
      return this.injectionEditor ?? this.inputEditor;
    }
    addTable({
      rows,
      cols
    }) {
      this.editor?.enter(); // @note: clear previous styles
      const prevLine = this.editor?.state?.selection.anchor;
      // @note: don't use `setHardBreak`,
      // it inherits styles of previous lines
      // required two line after
      this.editor?.enter();
      this.editor?.enter();
      this.editor?.setTextSelection(prevLine ?? 0);
      this.editor?.insertTable(rows, cols);
    }
    static {
      this.ɵfac = function TuiTableCreate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTableCreate)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiTableCreate,
        selectors: [["tui-table-create"]],
        inputs: {
          inputEditor: [0, "editor", "inputEditor"]
        },
        decls: 8,
        vars: 9,
        consts: [["table", ""], ["tableDropdown", ""], ["tuiDropdownAlign", "left", "tuiDropdownDirection", "bottom", 3, "tuiDropdown", "tuiDropdownOpen"], ["appearance", "icon", "automation-id", "toolbar__insert-table-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "iconStart", "tuiHint"], [3, "selectSize"]],
        template: function TuiTableCreate_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2, 0)(2, "button", 3);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, TuiTableCreate_ng_template_6_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const tableDropdown_r3 = i0.ɵɵreference(7);
            i0.ɵɵproperty("tuiDropdown", tableDropdown_r3)("tuiDropdownOpen", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("iconStart", ctx.options.icons.insertTable)("tuiHint", i0.ɵɵpipeBind1(3, 5, ctx.insertTableText$));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx.insertTableText$), " ");
          }
        },
        dependencies: [AsyncPipe, TuiButton, i1.TuiDropdownOptionsDirective, i1.TuiDropdownDirective, i1.TuiDropdownOpen, i1.TuiHintDirective, i1.TuiHintDescribe, TuiTableSizeSelector],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiTableCreate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTableCreate };
